"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./Font"));
__export(require("./Encoding"));



//////////////////
// WEBPACK FOOTER
// ./~/@pdf-lib/standard-fonts/lib/index.js
// module id = 146
// module chunks = 1